import { URLS } from '@constants'
import {
  GETObjectDataParams,
  GETStyleSettingParams,
  POSTStyleSettingParams,
  ShortStyleSetting,
  StyleSetting,
} from '@types'

import { commonAPI } from './common.api'

export const styleSettingAPI = commonAPI.injectEndpoints({
  endpoints: build => ({
    fetchAllStyleSettings: build.query<ShortStyleSetting[], GETObjectDataParams | void>({
      query: params => ({
        url: URLS.MOBILE_CFG + '/styleSetting/list',
        params: {
          searchPattern: params?.searchPattern,
          sort: params?.sort,
        },
      }),
      providesTags: ['AllStyleSettings'],
    }),
    fetchStyleSettingById: build.query<StyleSetting, GETStyleSettingParams>({
      query: ({ id }) => ({
        url: URLS.MOBILE_CFG + `/styleSetting/id/${id}`,
      }),
      providesTags: ['SingleStyleSetting'],
    }),
    createOrUpdateStyleSetting: build.mutation<StyleSetting, POSTStyleSettingParams>({
      query: styleSetting => ({
        url: URLS.MOBILE_CFG + `/styleSetting`,
        method: 'POST',
        body: styleSetting,
      }),
      invalidatesTags: ['AllStyleSettings', 'SingleStyleSetting'],
    }),
    deleteStyleSetting: build.mutation<void, number | string>({
      query: id => ({
        url: URLS.MOBILE_CFG + `/styleSetting/id/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['AllStyleSettings', 'SingleStyleSetting'],
    }),
  }),
})

export const {
  useFetchAllStyleSettingsQuery,
  useFetchStyleSettingByIdQuery,
  useCreateOrUpdateStyleSettingMutation,
  useDeleteStyleSettingMutation,
} = styleSettingAPI
